import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { loginPost } from "../../resources/AuthResource.js";
import { showErrorToast } from "../../utils/GlobalToast.js";
import { version_app } from "../../constants/Constant.js";

function Login() {
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const navigate = useNavigate();

  const postLogin = (username, password) => {

    loginPost(username, password)
      .then((res) => {
        navigate("/admin/*");
        window.location.reload();
      })
      .catch((err) => {
        showErrorToast(err);
      });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    postLogin(username, password);
  };

  return (<div className="row">
    <div className="col-12 col-lg-7 mx-auto">
      <div className="card radius-15 overflow-hidden">
        <div className="row g-0">
          <div className="col-xl-6">
            <div className="card-body p-5">
              <div className="text-center">
                <img src="../assets/images/icon-ravelware.png" width="80" alt="" />
                <h3 className="mt-2 font-weight-bold">WMS - RFID v{version_app}</h3>
              </div>
              <div className="">
                <div className="login-separater text-center mb-4"> <span>OR SIGN IN WITH EMAIL</span>
                  <hr />
                </div>
                <div className="form-body">
                  <form className="row g-3" onSubmit={handleSubmit}>
                    <div className="col-12">
                      <label className="form-label">Username</label>
                      <input type="text" className="form-control" id="inputUsername" placeholder="Username" value={username}
                        onChange={(e) => setUsername(e.target.value)} required />
                    </div>
                    <div className="col-12">
                      <label className="form-label">Enter Password</label>
                      <div className="input-group" id="show_hide_password">
                        <input type="password" className="form-control border-end-0" id="inputChoosePassword" placeholder="Enter Password" value={password}
                          onChange={(e) => setPassword(e.target.value)} required /> <a href="#section" className="input-group-text bg-transparent"><i className="bx bx-hide"></i></a>
                      </div>
                    </div>
                    <div className="col-12">
                      <div className="d-grid">
                        <button type="submit" className="btn btn-dark"><i className="bx bxs-lock-open"></i>Sign in</button>
                      </div>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
          <div className="col-xl-6 bg-login-color d-flex align-items-center justify-content-center">
            <img src="../assets/images/login-images/images-warehouse.png" className="img-fluid" alt="" />
          </div>
        </div>
      </div>
    </div>
  </div>);
}

export default Login;
